(async function () {
  const singlePageDiamondID = document.URL.split('/')[5]; // Split the string into an array with / as separator
  const singlePageDiamond = await fetchDiamond(singlePageDiamondID);
  const selectedRing = JSON.parse(document.querySelector('#ring-cart-data').value);
  try {
    fetch(`${window.HPDiamondsAppURL}/products/check/${singlePageDiamondID}`);
  } catch (error) {
    console.log(error);
  }

  async function fetchDiamond(id) {
    try {
      const res = await fetch(`${window.HPDiamondsAppURL}/diamonds/${id}`);
      const diamond = await res.json();
      return diamond.diamond;
    } catch (error) {
      console.log(error);
    }
  }

  function addBusinessDays(numDays) {
    const date = new Date();
    let count = 0;

    while (count < numDays) {
      date.setDate(date.getDate() + 1); // Increment the date by one day

      // Check if the current day is a weekend (Saturday or Sunday)
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        count++;
      }
    }

    return date;
  }

  class SingleDiamond extends HTMLElement {
    constructor() {
      super();
      this.diamondSelected = singlePageDiamond;
      this.diamondTitle = this.querySelector('#diamond-title');
      this.diamondShipDate = this.querySelector('#diamond-shipping span');
      this.diamondDescription = this.querySelector('#diamond-description');
      this.diamondPrice = this.querySelector('#diamond-price');
      this.iframeWrapper = this.querySelector('.iframe-wrapper');
      this.diamondFeaturedImage = this.querySelector('#diamond-featured-img');
      this.diamondFeaturedVideo = this.querySelector('#diamond-featured-video');
      this.diamondIframePlaceholderThumbnail = this.querySelector('.placeholder-for-iframe-thumbnail');
      this.diamondIframePlaceholder = this.querySelector('.placeholder-for-iframe');
      this.diamondImagePlaceholderThumbnail = this.querySelector('.placeholder-for-image-thumbnail');
      this.diamondImagePlaceholder = this.querySelector('.placeholder-for-image');
      this.diamondThumbnailImage = this.querySelector('#diamond-thumbnail-img');
      this.diamondThumbnailVideo = this.querySelector('#diamond-thumbnail-video');
      this.diamondType = this.querySelector('.detail-type--content');
      this.diamondShape = this.querySelector('.detail-shape--content');
      this.diamondCut = this.querySelector('.detail-cut--content');
      this.diamondColour = this.querySelector('.detail-colour--content');
      this.diamondSize = this.querySelector('.detail-size--content');
      this.diamondClarity = this.querySelector('.detail-clarity--content');
      this.diamondFlourescence = this.querySelector('.detail-flourescence--content');
      this.diamondMeasurements = this.querySelector('.detail-measurements--content');
      this.diamondPolish = this.querySelector('.detail-polish--content');
      this.diamondSymmetry = this.querySelector('.detail-symmetry--content');
      this.diamondRatio = this.querySelector('.detail-ratio--content');
      this.diamondCertificate = this.querySelector('.detail-certificate--content');
      this.diamondLab = this.querySelector('.diamond-lab-accordion');
      this.diamondLabLink = this.querySelector('.diamond-lab-accordion--link');
      this.diamondIframeLayer = this.querySelector('.iframe-wrapper--layer');
      this.diamondTooltipInputs = this.querySelectorAll('.detail-tooltip-input');
      this.diamondTooltipInputs.forEach((tooltip) => {
        tooltip.addEventListener('click', this.handleTooltips.bind(this, tooltip));
      });
      this.renderInfo();
    }

    renderInfo() {
      let {
        carats,
        shape,
        pdfUrl,
        labgrown,
        width,
        lab,
        depth,
        color,
        clarity,
        cut,
        polish,
        length,
        symmetry,
        floCol,
        image,
        video,
      } = this.diamondSelected.diamond.certificate;
      const { markup_price, GBP_markup_price } = this.diamondSelected;
      shape = shape.toLowerCase();
      if (shape.toLowerCase().includes('cushion')) {
        shape = 'Cushion';
      }
      this.diamondTitle.textContent = `${carats && carats + 'ct'} ${shape && shape} Diamond, ${color && color} ${
        clarity && clarity
      } - ${lab} certified`;
      this.currentLab = lab;
      console.table(
        carats,
        shape,
        pdfUrl,
        labgrown,
        width,
        lab,
        depth,
        color,
        clarity,
        cut,
        polish,
        length,
        symmetry,
        floCol,
        image,
        video
      );
      this.diamondDescription.textContent = `${labgrown ? 'Lab-grown' : 'Natural'} Diamond, ${
        color ? color + ' Colour,' : ''
      } ${clarity ? clarity + ' Clarity,' : ''} ${cut ? cut + 'Cut,' : ''} ${polish ? polish + ' Polish,' : ''} ${
        symmetry ? symmetry + ' Symmetry,' : ''
      } ${floCol ? floCol + ' Fluorescence' : ''}`;
      this.diamondType.textContent = `${
        labgrown ? 'Type' + ': ' + 'Lab-grown Diamond' : 'Type' + ': ' + 'Natural Diamond'
      }`;
      if (image == null && video == null) {
        if (window.Flickity)
          document.querySelectorAll('.flickity-slider img').forEach((img) => {
            img.src = window.placeholder_images[`${singlePageDiamond.diamond.certificate.shape}`];
          });
      }
      this.addToRingHandle(shape);
      this.handleTextContent(this.diamondShape, shape, 'shape');
      this.handleTextContent(this.diamondCut, cut, 'cut');
      this.handleTextContent(this.diamondColour, color, 'Colour');
      this.handleTextContent(this.diamondSize, carats, 'carats');
      this.handleTextContent(this.diamondClarity, clarity, 'clarity');
      this.handleTextContent(this.diamondFlourescence, floCol, 'floCol');
      this.handleTextContent(this.diamondPolish, polish, 'polish');
      this.handleTextContent(this.diamondSymmetry, symmetry, 'symmetry');
      this.handleTextContent(this.diamondCertificate, lab, 'Certificate');
      this.handleTextContent(this.diamondLabLink, lab, false); //, "Certified");
      this.handleTextContent(this.diamondLab, lab, 'Certified');
      if (pdfUrl && lab != 'GIA' && this.diamondLabLink) {
        this.handleTextContent(this.diamondLabLink, pdfUrl, null, true);
        if (lab == 'HRD') {
          this.diamondLabLink.querySelector('img').src = this.diamondLabLink.dataset.hrdImage;
        } else if (lab == 'WGI') {
          this.diamondLabLink.querySelector('img').src = this.diamondLabLink.dataset.wgiImage;
        } else {
          this.diamondLabLink.querySelector('img').src = this.diamondLabLink.dataset.igiImage;
        }
      }

      const shippingTime = addBusinessDays(+this.diamondSelected.diamond.delivery_time.max_business_days);

      this.diamondShipDate.textContent = shippingTime.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      });
      this.diamondMeasurements.innerHTML = `<b style="margin-right: -4px;">Measurements</b>: ${width} x ${length} x ${depth}`;
      this.diamondRatio.innerHTML = `<b style="margin-right: -4px;">Ratio</b>: ${(length / width).toFixed(2)}`;

      // this.handlePrice(markup_price).then((done) => {
      //   this.diamondPrice.innerHTML = done; // --> 'done!'
      // });
      this.diamondPrice.innerHTML = wetheme.formatMoney(GBP_markup_price, wetheme.moneyFormat);

      this.diamondIframeLayer && this.diamondIframeLayer.addEventListener('mouseup', this.handleLayer.bind(this));
      this.diamondIframePlaceholderThumbnail.src = window.placeholder_images[shape.toUpperCase()];
      this.diamondImagePlaceholderThumbnail.src = window.placeholder_images[shape.toUpperCase()];
      
      if (video !== null) {
        this.diamondFeaturedVideo.src = video.replace('/500/500', '');
        this.diamondFeaturedVideo.removeAttribute('hidden');
        this.diamondIframePlaceholder.remove();
        if (image !== null) {
          this.diamondThumbnailVideo.src = image;
          this.diamondThumbnailVideo.removeAttribute('hidden');
          this.diamondIframePlaceholderThumbnail.remove();
        }
      }
      if (video == null) {
        this.iframeWrapper.remove();
        this.diamondIframePlaceholderThumbnail.remove();
      }
      if (image !== null) {
        this.diamondFeaturedImage.src = image;
        this.diamondFeaturedImage.removeAttribute('hidden');
        this.diamondImagePlaceholder.remove();
        this.diamondThumbnailImage.src = image;
        this.diamondThumbnailImage.removeAttribute('hidden');
        this.diamondImagePlaceholderThumbnail.remove();
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 500);
      /*if(image !== null){
        this.renderMedia(this.diamondFeaturedImage, this.diamondThumbnailImage, image, image)
        this.diamondImagePlaceholderThumbnail.remove()
        this.diamondImagePlaceholder.remove()
      }
      if(video !== null && image !== null){
        console.log('acacsas')
        this.renderMedia(this.diamondFeaturedVideo, this.diamondThumbnailVideo, video.replace('/500/500', ''), image)
        this.diamondIframePlaceholderThumbnail.remove()
        this.diamondIframePlaceholder.remove()
      }
      if(video !== null && image == null){
        console.log('accaaa')
        this.renderMedia(this.diamondFeaturedVideo, null, video.replace('/500/500', ''), null)
        this.diamondIframePlaceholder.remove()
      }*/
    }

    addToRingHandle() {
      const { GBP_markup_price } = this.diamondSelected;
      const { carats, shape, clarity, color } = this.diamondSelected.diamond.certificate;
      let customShape = shape.toLowerCase();
      customShape = customShape.charAt(0).toUpperCase() + customShape.slice(1);
      if (customShape.toLowerCase().includes("cushion")) {
        customShape = "Cushion";
      }
      const btn = this.querySelector("#add_to_ring_btn");
      const title = `${carats && carats + "ct"} ${shape && shape + " Diamond"}`;
      const fullRingTitle = `${carats && carats + " Carat | "}${shape.toLowerCase() && shape.toLowerCase() + " Shaped Diamond | "}${
        color && color + " Colour | "
      }${clarity && clarity + " Clarity"}`;
      // const link = `/collections/${shape.toLowerCase()}-engagement-rings?view=select-ring`;
      const image = this.diamondSelected.diamond.certificate.image || window.placeholder_images[shape.toUpperCase()];
      customShape = customShape.includes("Cushion") ? "Cushion" : customShape;
      const link = `/collections/engagement-rings-in-hatton-garden?filter.p.m.custom.shape=${customShape}&sort_by=best-selling&view=select-ring`;

      // add diamond id to cart attribute
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        toggleLoader();
        localStorage.setItem("selectedLab", this.currentLab);
        await fetch("/cart.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;",
          },
          body: JSON.stringify({
            attributes: {
              tempShape: customShape.toLowerCase(),
              diamond: {
                id: singlePageDiamondID,
                title,
                price: GBP_markup_price,
                fullRingTitle,
                image,
                shape: customShape,
              },
            },
          }),
        });
        if (btn.dataset.isComplete === "true") {
          window.location = "/pages/full-ring";
        } else {
          window.location = link + "&" + new Date().getTime();
        }
        toggleLoader();
      });
    }
    // handlePrice(price) {
    //   return new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //       let priceInLocalCurrency = Math.round(
    //         price / this.getCookie("currentCurrencyTo_USD")
    //       );
    //       priceInLocalCurrency = Math.round(priceInLocalCurrency / 100) * 100;
    //       priceInLocalCurrency = Math.round(priceInLocalCurrency / 1000) * 1000;
    //       resolve(
    //         wetheme.formatMoney(priceInLocalCurrency, wetheme.moneyFormat)
    //       );
    //     }, 100);
    //   });
    // }
    // getCookie(name) {
    //   const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    //   return match ? match[2] : null;
    // }
    handleTextContent(element, innerContent, addText = null, isLink = false) {
      if (!element) return console.error('Element not found');
      if (element && (addText === 'certificate' || addText === 'Certificate')) {
        element.innerHTML = `${
          innerContent
            ? addText
              ? "<b style='margin-right: -4px;'>" +
                addText +
                '</b>' +
                ': ' +
                innerContent +
                ' | ' +
                `<a target="_blank" href=${this.diamondSelected.diamond.certificate.pdfUrl}>View certificate</a>`
              : innerContent
            : ''
        }`;
      } else if (element && !isLink && addText !== false) {
        addText == 'carats' ? (innerContent = parseFloat(innerContent).toFixed(2)) : innerContent;
        addText = addText == 'carats' ? 'Carat weight' : addText;
        element.innerHTML = `${
          innerContent
            ? addText
              ? "<b style='margin-right: -4px;'>" + addText + '</b>:' + ' ' + innerContent
              : innerContent
            : ''
        }`;
      }
      if (element && isLink) {
        element.href = `${innerContent ? innerContent : '#'}`;
      }
    }
    handleLayer() {
      this.diamondIframeLayer.style.display = 'none';
    }
    handleTooltips(input) {
      this.diamondTooltipInputs.forEach((tooltip) => (tooltip.checked = false));
      input.checked = true;
    }
  }

  class FourCDiamond extends HTMLElement {
    constructor() {
      super();
      this.diamondSelected = singlePageDiamond;
      this.diamondCaratWrapper = this.querySelector('.hp-diamond-carat');
      this.diamondCaratMeasurementsContent = this.querySelector('.hp-diamond-carat--measurements_content');
      this.diamondColorWrapper = this.querySelector('.hp-diamond-color');
      this.diamondCutWrapper = this.querySelector('.hp-diamond-cut');
      this.diamondClarityWrapper = this.querySelector('.hp-diamond-clarity');
      this.diamondClarityDescription = this.diamondClarityWrapper.querySelectorAll('.hp-diamond-clarity--desc-text');
      this.diamondColorDescription = this.diamondColorWrapper.querySelectorAll('.hp-diamond-color--desc-text');

      this.renderInfo();
    }
    renderInfo() {
      let {
        carats,
        shape,
        depth,
        width,
        length,
        labgrown,
        color,
        clarity,
        cut,
        polish,
        symmetry,
        floCol,
        image,
        video,
      } = this.diamondSelected.diamond.certificate;
      width = parseFloat(width).toString();
      length = parseFloat(length).toString();
      depth = parseFloat(depth).toString();
      this.renderTitle(this.diamondCaratWrapper, `${carats}ct`);
      this.renderTitle(this.diamondColorWrapper, `${color}`);
      this.renderTitle(this.diamondCutWrapper, `${cut}`);
      this.renderTitle(this.diamondClarityWrapper, `${clarity}`);
      this.diamondCaratMeasurementsContent.textContent = `${width} x ${length} x ${depth}mm`;
      this.renderRange(this.diamondColorWrapper, color);
      this.renderRange(this.diamondClarityWrapper, clarity);
      this.diamondColorWrapper.querySelector('.title-type').textContent = ` ${
        color == 'D' || color == 'E' || color == 'F'
          ? 'Colourless'
          : color == 'G' || color == 'H' || color == 'I' || color == 'J'
          ? 'Near Colourless'
          : 'Noticeable Colourless'
      }`;
      this.renderDescription(this.diamondColorDescription, color);
      this.renderDescription(this.diamondClarityDescription, clarity);
    }
    renderTitle(wrapper, content) {
      if (wrapper.classList.contains('hp-diamond-cut')) {
        if (singlePageDiamond.diamond.certificate.shape == 'ROUND') {
          wrapper.querySelectorAll('.title').forEach((title) => (title.textContent = content));
          wrapper.querySelector('.hp-diamond-types--single:nth-of-type(3) span').textContent =
            singlePageDiamond.diamond.certificate.polish;
          wrapper.querySelector('.hp-diamond-types--single:nth-of-type(4) span').textContent =
            singlePageDiamond.diamond.certificate.symmetry;
        } else {
          wrapper.querySelectorAll('.title').forEach((title) => (title.textContent = 'N/A'));
          wrapper.querySelector(
            '.cut__content'
          ).textContent = `While cut grade is an important consideration for round diamonds, it's essential to understand that this grading only applies to round shapes.
          For diamonds in any other shape, such as princess, emerald, or oval, they are already uniquely cut to enhance their inherent beauty and characteristics. As a result, they do not have a cut grade as an option.
          Rest assured that these diamonds undergo meticulous craftsmanship to ensure they exhibit optimal brilliance and fire, regardless of the absence of a cut grade.
          However, it's important to note that these diamonds do have polish and symmetry grading, which contribute to their overall appearance and quality. Our team carefully selects and evaluates each diamond on these factors to ensure they exhibit optimal brilliance and fire.
          If you have any further questions or need assistance in selecting the perfect diamond for your needs, please don't hesitate to reach out. We're here to help you find the ideal diamond for your special occasion.`;

          const firstProperty = wrapper.querySelector('.hp-diamond-types--single:nth-of-type(1)');
          const secondProperty = wrapper.querySelector('.hp-diamond-types--single:nth-of-type(2)');

          if (firstProperty) {
            firstProperty.style.display = 'none';
          }

          if (secondProperty) {
            secondProperty.style.display = 'none';
          }
          wrapper.querySelector('.hp-diamond-types--single:nth-of-type(3) span').textContent =
            singlePageDiamond.diamond.certificate.polish;
          wrapper.querySelector('.hp-diamond-types--single:nth-of-type(4) span').textContent =
            singlePageDiamond.diamond.certificate.symmetry;
          wrapper.querySelector('.hp-diamond-types').style.justifyContent = 'flex-start';
          wrapper.querySelector('.hp-diamond-types').style.gap = '25px';
        }
      } else {
        wrapper.querySelectorAll('.title').forEach((title) => (title.textContent = content));
      }
    }
    renderRange(wrapper, content) {
      wrapper.querySelector(`[data-value=${content.toUpperCase()}]`).classList.add('active');
    }
    renderDescription(descriptionElements, currentValue) {
      descriptionElements.forEach((element) => {
        if (element.dataset.value != currentValue.toLowerCase()) {
          element.remove();
        }
      });
    }
  }

  customElements.define('four-c-diamond', FourCDiamond);
  customElements.define('single-diamond', SingleDiamond);
})();
